'use client';

import React, { FC, PropsWithChildren } from 'react';
import { GlobalStateProvider, ShaApplicationProvider, StoredFilesProvider, useNextRouter } from '@shesha-io/reactjs';
import { AppProgressBar } from 'next-nprogress-bar';
import { useTheme } from 'antd-style';
import { EnterpriseApplicationPlugin } from '@shesha-io/enterprise';
import { WorkflowApplicationPlugin } from '@shesha-io/workflow';

export interface IAppProviderProps {
  backendUrl: string;
  applicationKey: string;
}

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({ children, backendUrl, applicationKey }) => {
  const nextRouter = useNextRouter();
  const theme = useTheme();

  return (
    <GlobalStateProvider>
      <AppProgressBar height="4px" color={theme.colorPrimary} shallowRouting />
      <ShaApplicationProvider
        backendUrl={backendUrl}
        applicationKey={applicationKey}
        router={nextRouter}
        noAuth={nextRouter.path?.includes('/no-auth')}
      >
        <EnterpriseApplicationPlugin>
          <WorkflowApplicationPlugin>
            <StoredFilesProvider baseUrl={backendUrl} ownerId={''} ownerType={''}>
              {children}
            </StoredFilesProvider>
          </WorkflowApplicationPlugin>
        </EnterpriseApplicationPlugin>
      </ShaApplicationProvider>
    </GlobalStateProvider>
  );
};
